export enum CulturalLeadershipAccessLevels {
    CurrentPerson = "CurrentPerson",
    AnonymousAccess = "AnonymousAccess",
    QuantitativeAccess = "QuantitativeAccess",
    FullAccess = "FullAccess",
}